import { render, staticRenderFns } from "./PermissionCategoryTab.vue?vue&type=template&id=4b0e5aa0&"
import script from "./PermissionCategoryTab.vue?vue&type=script&lang=js&"
export * from "./PermissionCategoryTab.vue?vue&type=script&lang=js&"
import style0 from "./PermissionCategoryTab.vue?vue&type=style&index=0&id=4b0e5aa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports